<h1 class="text-accent-blue">{{ 'Terms Of Use' | translate }}</h1>

<e11-panel [contentClassOverrides]="'e11-p-6 e11-mb-8'">
  <cnect-loader-link *ngIf="isLoading" label="{{ 'Loading...' | translate }}"></cnect-loader-link>
  <p [innerHTML]="termsOfUse" *ngIf="!isLoading"></p>
</e11-panel>
